import React from 'react'
import { StatusBubble } from './StatusBubble'
import { BiStateItemContent } from './BiStateItemContent'
import { SingleStateItemContent } from './SingleStateItemContent'

export function StatusBarItem ({ status, index }) {
  const bubbleVariant = {
    DONE: 'full',
    IN_PROGRESS: 'half',
    TO_DO: 'empty'
  }[status.status] || 'empty'

  const contentComp = ['LOADING', 'UNLOADING', 'FERRY_PASSAGE', 'CUSTOMS_CONTROL', 'CUSTOM_INTERMEDIATE_POINT']
    .includes(status.type)
    ? BiStateItemContent
    : SingleStateItemContent

  return (
    <StatusBubble
      number={index + 1}
      variant={bubbleVariant}>
      {contentComp({ status })}
    </StatusBubble>
  )
}
